const DEVICE_ID_ALPHABET = "2346789ABCDEFGHJKMNPQRTUVWXY";
const DEVICE_ID_ALPHABET_LEN = DEVICE_ID_ALPHABET.length;
const DEVICE_ID_PAYLOAD_LEN = 8;
const DEVICE_ID_TOTAL_LEN = 9;

function alphabetIndex(ch) {
  const c = ch.toUpperCase();
  return DEVICE_ID_ALPHABET.indexOf(c);
}

// Weighted checksum: sum(idx * position) mod alphabet length
function computeDeviceIdCheckChar(payload) {
  let sum = 0;
  for (let i = 0; i < payload.length; i++) {
    const idx = alphabetIndex(payload[i]);
    if (idx < 0) {
      // invalid char — we'll reject elsewhere, but don't NaN the checksum
      continue;
    }
    sum += idx * (i + 1); // position-weighted to catch transpositions
  }
  const checkIndex = sum % DEVICE_ID_ALPHABET_LEN;
  return DEVICE_ID_ALPHABET[checkIndex];
}

export function normalizeDeviceIdInput(raw) {
  if (!raw) return "";
  let s = raw.trim().toUpperCase();

  // Remove anything that isn't 0–9 or A–Z (hyphens, spaces, etc.)
  s = s.replace(/[^0-9A-Z]/g, "");

  return s;
}

export function validateDeviceId(raw) {
  const normalized = normalizeDeviceIdInput(raw);

  // Length check
  if (normalized.length !== DEVICE_ID_TOTAL_LEN) {
    return {
      ok: false,
      reason: "length",
      message: `Device ID must be ${DEVICE_ID_TOTAL_LEN} characters long.`,
    };
  }

  // Character set check
  for (const ch of normalized) {
    if (alphabetIndex(ch) === -1) {
      return {
        ok: false,
        reason: "chars",
        message: "This device ID doesn’t look right. Please double-check the label.",
      };
    }
  }

  const payload = normalized.slice(0, DEVICE_ID_PAYLOAD_LEN);
  const checkChar = normalized[DEVICE_ID_PAYLOAD_LEN];
  const expectedCheckChar = computeDeviceIdCheckChar(payload);

  if (checkChar !== expectedCheckChar) {
    return {
      ok: false,
      reason: "checksum",
      message: "This device ID doesn’t look right. Please double-check the label.",
    };
  }

  return {
    ok: true,
    deviceId: normalized, // canonical form, e.g. "ABCDWXYZJ"
  };
}

export function formatDeviceIdForDisplay(deviceId) {
  const s = normalizeDeviceIdInput(deviceId);
  if (s.length !== DEVICE_ID_TOTAL_LEN) return deviceId; // fallback

  const payload1 = s.slice(0, 4); // first 4 payload chars
  const payload2 = s.slice(4, 8); // next 4 payload chars
  const check = s.slice(8);       // last char

  return `${payload1}-${payload2}-${check}`; // ABCD-EFGH-J
}